import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  makeStyles,
  Box,
  Typography
} from '@material-ui/core';
import { Cached as ReloadIcon } from '@material-ui/icons';
import useAuth from 'src/hooks/useAuth';
import { useDispatch } from 'src/store';
import { logout } from 'src/slices/auth';

const useStyles = makeStyles((theme) => ({
  paper: {
    width: 500
  },
  image: {
    maxWidth: '100%',
    width: 560,
    maxHeight: 250,
    height: 'auto'
  },
  dialogAction: {
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 5
  }
}));

export default function UnActivatedUser() {
  const classes = useStyles();
  const {
    user: { userFirstName }
  } = useAuth();
  const dispatch = useDispatch();
  const history = useHistory();

  const handleLogout = async () => {
    await dispatch(logout());
    return history.push('/login');
  };

  const reloadPage = () => {
    return window.location.reload();
  };

  return (
    <Dialog
      open={true}
      classes={{
        paper: classes.paper
      }}
      maxWidth="lg"
    >
      <DialogContent>
        <Box
          my={2}
          display="flex"
          textAlign="center"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <Typography variant="h2" color="textSecondary">
            Hi, {userFirstName}
          </Typography>
          <br />
          <Typography color="textSecondary">
            Your account is yet to be activated.
            <br /> Kindly wait while we confirm your phone number.
          </Typography>
          <br />
          <img
            alt="unactivated user"
            className={classes.image}
            src="/static/user-skate.svg"
          />
          <Box mt={2}>
            <Typography>
              You can reload this page after an hour to check for update.
            </Typography>
            <Typography>
              If your account has not been activated after an hour, kindly send
              us a mail: <b>support@vezeti.net</b>
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions className={classes.dialogAction}>
        <Button color="secondary" variant="outlined" onClick={handleLogout}>
          Logout
        </Button>
        <Button
          color="secondary"
          variant="contained"
          startIcon={<ReloadIcon />}
          onClick={reloadPage}
        >
          Reload page
        </Button>
      </DialogActions>
    </Dialog>
  );
}
